import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function TickCircle({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <TickCircle.Outline {...props} />
  ) : (
    <TickCircle.Solid {...props} />
  );
}

TickCircle.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M16.5003 10.3673C16.8258 10.0419 16.8258 9.51422 16.5003 9.18878C16.1749 8.86334 15.6473 8.86334 15.3218 9.18878L10.6376 13.873L8.58909 11.8253C8.26359 11.5 7.73595 11.5001 7.41058 11.8256C7.08521 12.1511 7.08532 12.6787 7.41083 13.0041L10.0486 15.6407C10.3741 15.9661 10.9016 15.966 11.227 15.6406L16.5003 10.3673Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 12C2 17.5233 6.47784 22 12 22C17.5222 22 22 17.5233 22 12C22 6.47779 17.5222 2 12 2C6.47779 2 2 6.47779 2 12ZM12 20.5C7.30616 20.5 3.5 16.6947 3.5 12C3.5 7.30621 7.30621 3.5 12 3.5C16.6938 3.5 20.5 7.30621 20.5 12C20.5 16.6947 16.6938 20.5 12 20.5Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

TickCircle.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          d="M0 12C-2.34822e-08 10.4241 0.310389 8.86371 0.913445 7.4078C1.5165 5.95189 2.40042 4.62902 3.51472 3.51472C4.62902 2.40042 5.95189 1.5165 7.4078 0.913446C8.86371 0.310389 10.4241 0 12 0C13.5759 0 15.1363 0.310389 16.5922 0.913446C18.0481 1.5165 19.371 2.40042 20.4853 3.51472C21.5996 4.62902 22.4835 5.95189 23.0866 7.4078C23.6896 8.86371 24 10.4241 24 12C24 15.1826 22.7357 18.2348 20.4853 20.4853C18.2348 22.7357 15.1826 24 12 24C8.8174 24 5.76515 22.7357 3.51472 20.4853C1.26428 18.2348 4.74244e-08 15.1826 0 12Z"
          className="icon-secondary"
        />
        <path
          d="M7.57812 12.6293L10.1044 15.1556L16.4202 8.83984"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon-outline"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
